const initialState = {
  banks: [],
  ownerTypes: [],
  accountType: [],
  isFetching: false,
  isFetched: false,
  error: false
}

export const OWNER_TYPES = {
  'Conta Individual': 'IndividualAccount',
  'Conta Conjunta': 'JointAccount'
}

export const OWNER_TYPES_TRANSLATE = {
  IndividualAccount: 'Conta Individual',
  JointAccount: 'Conta Conjunta'
}

export const ACTION_TYPES = {
  BANK_INFO_ACCOUNT_REQUEST: 'BANK_INFO_ACCOUNT_REQUEST',
  BANK_INFO_ACCOUNT_SUCCESS: 'BANK_INFO_ACCOUNT_SUCCESS',
  BANK_INFO_ACCOUNT_ERROR: 'BANK_INFO_ACCOUNT_ERROR',
  BANKS_LIST_REQUEST: 'BANKS_LIST_REQUEST',
  BANKS_LIST_SUCCESS: 'BANKS_LIST_SUCCESS',
  BANKS_LIST_ERROR: 'BANKS_LIST_ERROR'
}

export const getBankInfo = () => ({
  type: ACTION_TYPES.BANK_INFO_ACCOUNT_REQUEST
})

export const getBanksList = (payload = {}) => ({
  type: ACTION_TYPES.BANKS_LIST_REQUEST,
  payload
})

const bankInfo = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.BANK_INFO_ACCOUNT_REQUEST:
    case ACTION_TYPES.BANKS_LIST_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false
      }
    case ACTION_TYPES.BANK_INFO_ACCOUNT_SUCCESS:
    case ACTION_TYPES.BANKS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        ...payload
      }
    case ACTION_TYPES.BANK_INFO_ACCOUNT_ERROR:
    case ACTION_TYPES.BANKS_LIST_ERROR:
      return {
        ...initialState,
        error: true
      }
    default:
      return { ...state }
  }
}

export default bankInfo
